import React from 'react'
import LazyLoad from 'react-lazyload'
import { Button, Popconfirm, Modal } from "antd"
import { UploadOutlined, DeleteOutlined, EyeTwoTone } from '@ant-design/icons'

const AddImage = (props) => {
    const {
        packageMockup = [],
        isOpenPreview = false,
        onRemoveImage,
        isLoading = false,
        inputFileRef,
        onFileChange,
        imageSelect,
        onAddImage,
        className,
        onViewImage,
    } = props

    return (
        <div className={`${className} itemInfo mr-5 mb-3 d-flex align-items-center`}>
            <label className="font-weight-bold mb-0 mr-2"></label>
            <div className="block-image d-flex align-items-center">
                {
                    !!packageMockup.length &&
                    <div className="d-flex align-items-center">
                        {
                            packageMockup.map((item, index) => (
                                <div className="image-item-upload mr-3 position-relative" key={index}>
                                    <LazyLoad>
                                        <img
                                            src={item}
                                            alt="preview"
                                            loading='lazy'
                                        />
                                        <Popconfirm
                                            placement="topRight"
                                            title="Bạn chắc chắn muốn xóa ảnh này?"
                                            onConfirm={(e) => onRemoveImage(e, item)}
                                            okText="Xóa"
                                            cancelText="Không"
                                        >
                                            <DeleteOutlined className='delete-image-item' />
                                        </Popconfirm>
                                        <EyeTwoTone
                                            className='eyes-image-item'
                                            onClick={() => onViewImage('view', item)}
                                        />
                                        <Modal
                                            visible={isOpenPreview && item === imageSelect}
                                            onCancel={() => onViewImage('cacel')}
                                            closable={false}
                                            footer={false}
                                            width={"50vw"}
                                            height={"75vh"}
                                        >
                                            <img
                                                src={item}
                                                alt="preview"
                                                width={"100%"}
                                                style={{ objectFit: 'contain' }}
                                            />
                                        </Modal>
                                    </LazyLoad>
                                </div>
                            ))
                        }
                    </div>
                }
                {
                    packageMockup.length < 3 &&
                    <div className="d-flex align-items-center">
                        <Button
                            type='default'
                            icon={<UploadOutlined />}
                            onClick={onAddImage}
                            loading={isLoading}
                            disabled={isLoading}
                        >
                            Thêm ảnh
                        </Button>
                    </div>
                }
            </div>
            <input
                type="file"
                accept="image/*"
                ref={inputFileRef}
                hidden
                onChange={onFileChange}
            />
        </div>
    )
}

export default AddImage